import { Card, Typography, Divider, CardContent, Box, Tabs, Tab } from '@mui/material';
import { ReactNode, useState } from 'react';
import { useI18n } from 'iomart-hooks';
import { TableTabs } from 'src/@types/table';

type ChildrenFunc = (props: {tab: string}) => ReactNode

interface CardBlockProps {
  title?: ReactNode;
  children: ReactNode | ChildrenFunc;
  tabs?: TableTabs;
  noShadow?: boolean;
}

export const CardBlock = ({ title, children, tabs, noShadow = false }: CardBlockProps) => {
  const { t } = useI18n(false);
  const [tabValue, setTabValue] = useState(tabs?.find(tab => tab.isDefault)?.value);

  return (
    <Card sx={{ boxShadow: noShadow ? 'none' : undefined }}>
      {title && !tabs && (
        <>
          <Box px={3} py={1}>
            {typeof title === 'string' ? (
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                {t(title)}
              </Typography>
            ) : (
              title
            )}
          </Box>
          <Divider />
        </>
      )}
      {tabs && (
        <>
          <Box px={3}>
            <Tabs
              allowScrollButtonsMobile={false}
              variant="scrollable"
              value={tabValue}
              onChange={(_, value) => setTabValue(value)}
            >
              {tabs.map((tab: any) => (
                <Tab disableRipple key={tab.value} value={tab.value} label={t(tab.label)} />
              ))}
            </Tabs>
          </Box>
          <Divider />
        </>
      )}
      <CardContent sx={{ py: 2 }}>{typeof children === 'function' ? children({ tab: tabValue || '' }) : children}</CardContent>
    </Card>
  );
}
